import { useQuery } from "@tanstack/react-query";
import merchant_services from "services/merchant_services";
import type { MerchantSettlementInfo } from "utils/AxiosUtil";

// Lazily fetch a merchant's settlement metadata (platform + live/sandbox mode)
// by merchantId. `enabled` gates the request so it only fires when the row's
// detail is expanded; react-query caches per merchantId, so re-expanding is
// instant.
export function useMerchantSettlement(merchantId: string, enabled: boolean) {
  return useQuery<MerchantSettlementInfo>({
    queryKey: ["merchantSettlement", merchantId],
    queryFn: () => merchant_services.fetchMerchantSettlement(merchantId),
    enabled: enabled && !!merchantId,
  });
}
